(function () {
  'use strict';

  angular.module('app').component('hotelList', hotelList());

  function hotelList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowItem: '&',
        defaultLanguage: '<',
        userLanguageCode: '<',
      },
      controller: HotelListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/hotels/hotel-list/hotel-list.component.html',
    };
  }

  HotelListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'HotelService',

    // Angular downgraded service
    'locationService',
  ];

  function HotelListComponent(config, UtilService, AbilityService, HotelService, locationService) {
    let vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_hotel_accountadmin'),
      canUpdate: AbilityService.can('update_hotel_accountadmin'),
      canDestroy: AbilityService.can('destroy_hotel_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.filterCriteria = HotelService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;

    vm.searchLocations = (search) => {
      if (search.length < 2) {
        return;
      }

      let params = {
        get: 'active',
        by_name: search,
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      locationService.getLocations(params).subscribe((response) => {
        vm.locations = response;
      });
    };

    function fetchResult() {
      // vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      HotelService.getHotels(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = HotelService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.onShowItem({ item: item, mode: mode });
    }

    function deleteItem(item) {
      if (!vm.permissions.canDestroy) {
        return;
      }

      HotelService.deleteHotel(item, fetchResult);
    }

    function changeItemStatus(item) {
      if (!vm.permissions.canUpdate) {
        return;
      }

      HotelService.changeHotelStatus(item);
    }
  }
})();
